import { render } from "./GamerSelect.vue?vue&type=template&id=b4831548&scoped=true"
import script from "./GamerSelect.vue?vue&type=script&lang=js"
export * from "./GamerSelect.vue?vue&type=script&lang=js"

import "./GamerSelect.vue?vue&type=style&index=0&id=b4831548&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b4831548"

export default script